export const atLeastOneNumber = (value: string) => {
  return /.*[0-9]+.*/.test(value);
};

export const atLeastOneLowercase = (value: string) => {
  return /.*[a-z]+.*/.test(value);
};

export const atLeastOneUppercase = (value: string) => {
  return /.*[A-Z]+.*/.test(value);
};
